import { render, staticRenderFns } from "./SettingsComponentHeader.vue?vue&type=template&id=85749270&scoped=true&lang=pug&"
import script from "./SettingsComponentHeader.vue?vue&type=script&lang=ts&"
export * from "./SettingsComponentHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsComponentHeader.vue?vue&type=style&index=0&id=85749270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85749270",
  null
  
)

export default component.exports